import { Provider } from '@angular/core/core';

import { WidgetObserverService } from './widget-observer.service';
import { WidgetObserverStateService } from './widget-observer-state.service';

export * from './widget-observer.service';

export const WidgetObserverProviders: Provider[] = [
  WidgetObserverService,
  WidgetObserverStateService
];
